//PUNS
/**
 * emPEZar :D
 */

/**
 * TODO
 * cuando no está el navegador mostrandose pausar los setTimer o algo
 */


import css from '/style/style.scss';
const createPlayer = require('web-audio-player');
const createAudioContext = require('ios-safe-audio-context');
var createAnalyser = require('web-audio-analyser');

var aCtx = '';

//AUDIO PRELOADER
var audioFiles = [
    "./instrucciones.mp3",
    "./musica.mp3",
    "./gameover.mp3",
    "./mero.mp3",
    "./antonito2.mp3",
    "./antonito.mp3",
    "./bocinero.mp3",
    "./lapas2.mp3",
    "./lapas1.mp3",
    "./comocamaron.mp3",
    "./fallo5.mp3",
    "./fallo3.mp3",
    "./fallo1.mp3",
    "./felicitaciones.mp3",
    "./pulpo2.mp3",
    "./caballa3.mp3",
    "./caballa2.mp3",
    "./caballa1.mp3",
    "./cabrilla.mp3",
    "./general3.mp3",
    "./abade.mp3",
    "./general2.mp3",
    "./general1.mp3",
    "./lubina.mp3",
    "./bonito.mp3",
    "./besugo.mp3",
    "./olimpo2.mp3",
    "./dorada.mp3",
    "./vieja.mp3",
    "./samadepluma.mp3",
    "./samadeplumas2.mp3",
    "./chopa.mp3",
    "./chopa2.mp3",
    "./breca.mp3",
    "./pulpo.mp3",
    "./salema2.mp3",
    "./salema.mp3",
    "./sargoblanco.mp3",
    "./olimpo.mp3"
];

function preloadAudio(url) {
    var audio = new Audio();
    //audio.preload = 'auto';
    // once this file loads, it will call loadedAudio()
    // the file will be kept by the browser as cache
    audio.addEventListener('canplaythrough', loadedAudio, false);
    audio.src = url;
    audio.load();
}

var loaded = 0;
function loadedAudio() {
    // this will be called every time an audio file is loaded
    // we keep track of the loaded files vs the requested files
    loaded++;
    if (loaded == audioFiles.length) {
        // all AUDIOS loaded
        //LET'S GO WITH THE FISHA
    }
}

const dbHelper = {
    preload: function () {
        import(/* webpackChunkName: "db" */ './db.js').then(module => {
            dbHelper.db = module;
        });
    }
}

dbHelper.preload();

// we start preloading all the audio files
for (var i in audioFiles) {
    preloadAudio(audioFiles[i]);
}

//EN AUDIO PRELOADERR
// START IMAGE PRELOADER
function preloadImg(url) {
    var img = new Image();
    // once this file loads, it will call loadedAudio()
    // the file will be kept by the browser as cache
    img.onload = loadedImg;
    img.onerror = loadedImg;
    img.src = url;
}

var imgLoaded = 0;
function loadedImg() {
    // this will be called every time an audio file is loaded
    // we keep track of the loaded files vs the requested files
    imgLoaded++;
    if (imgLoaded == game.easyData.length) {
    }
}


const help = {
    randomIntervallCaller: function (min, max, callback) {
        setTimeout(function () {
            callback();
            help.randomIntervallCaller(min, max, callback);
        }, min + ((max - min) * Math.random()));
    },
    maxWidth: function (titulo) {
        for (let i = 1; i < 10; i += 0.2) {
            titulo.style.fontSize = i + 'rem';
            if (help.isTextBiggerThan(titulo, titulo.parentElement.getBoundingClientRect().width)) {
                titulo.style.fontSize = (i - 0.2) + 'rem';
                break;
            }
        }
    },
    isTextBiggerThan: function (element, theWidth) {
        return (element.getBoundingClientRect().width > theWidth);
    },
    besugoBoca: function (angle) {
        document.getElementById('boca').style.transform = 'rotate(' + (angle * -1) + 'deg)';
    },
    //Valores entre -1 y 1
    besugoOjo: function (x, y) {
        try {
            document.getElementById('ojo').style.transform = 'translate(' + (x * 3) + '%,' + (y * 2) + '%)';
        } catch {

        }
    },
    besugoHabla: function () {
        help.boca = document.getElementById('boca')
        help.boca.classList.remove('bocamovement');
        //Prevent overflow bug on safari
        document.querySelector('.beshugo').parentElement.style.transform = '';
        help.loop = true;
        requestAnimationFrame(help.renderLoop);
    },
    besugoCalla: function () {
        help.loop = false;
        let boca = document.getElementById('boca');
        boca.style.transform = '';
        boca.classList.add('bocamovement');
        //Prevent overflow bug on safari
        document.querySelector('.beshugo').parentElement.style.transform = 'rotate(0deg)';
    },
    renderLoop: function () {
        help.boca.style.transform = 'rotate(-' + (help.audioUtil.frequencies()[256] / 3.5) + 'deg)';
        if (help.loop) {
            requestAnimationFrame(help.renderLoop);
        } else {
            help.boca.style.transform = '';
        }
    },
    createOpcion(value) {
        let container = document.createElement('div');
        container.classList.add('respuesta');
        let label = document.createElement('p');
        label.innerText = value;
        container.appendChild(label);
        container.onclick = function () {
            /*
            document.querySelectorAll('.respuesta').forEach(element => {
                element.style.border = '';
            })
            
            container.style.border = '4px solid #03a9f4';
            */
            game.checkRespuesta(label);
        }
        return container;
    },
    hablar: function (src, callbacks) {
        if (help.audio) {
            if (typeof help.audio.stop == 'function')
                help.audio.stop();
            delete help.audio;
        }
        help.audio = createPlayer(src, { context: aCtx, buffer: true, volume: 0.7 });
        help.audioUtil = createAnalyser(help.audio.node, help.audio.context, {
            stereo: false
        });

        help.analyser = help.audioUtil.analyser;
        help.besugoHabla();
        help.audio.node.connect(help.audio.context.destination)
        help.audio.play();
        help.audio.on('end', function () {
            help.besugoCalla();
            if (callbacks?.onend) {
                callbacks.onend();
                delete callbacks.onend;
            }
        });
        return help.audio;
    },
    getPhotoWithTittle(fish) {
        let container = document.createElement('div');
        let titulo = document.createElement('h2');
        titulo.innerText = fish.nombre;
        let img = new Image();
        img.src = fish.url;
        container.appendChild(img);
        container.appendChild(titulo);
        container.className = 'imagen';
        return container;
    },
    startMusic: function () {
        help.musica = createPlayer('./musica.mp3', { context: aCtx, buffer: true, loop: true, volume: 0.2 });
        help.musica.node.connect(help.musica.context.destination);
        help.musica.play();
    },
    stopMusic: function () {
        if (help.musica)
            help.musica.stop();
    },
    barajar: function (array) {
        let currentIndex = array.length, randomIndex;

        // While there remain elements to shuffle...
        while (currentIndex != 0) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;

    }
}

window.help = help;

const game = {
    easyData: [
        {
            nombre: 'ABADE',
            url: './img/abade.jpg',
            correct: '35 CM',
            suggested: ['35 CM', '40 CM', '30 CM'],
            audio: ['./abade.mp3']
        },
        {
            nombre: 'BESUGO',
            url: './img/besugo.jpg',
            correct: '20 CM en aguas exteriores \n12 CM en aguas interiores',
            suggested: ['12 CM en aguas exteriores \n20 CM en aguas interiores', '20 CM en aguas exteriores \n12 CM en aguas interiores', '14 CM en aguas exteriores \n20 CM en aguas interiores'],
            audio: ['./besugo.mp3']
        },
        {
            nombre: 'ANTOÑITO',
            url: './img/antonito.jpg',
            correct: '22 CM en aguas exteriores \n18 CM en aguas interiores',
            suggested: ['40 CM en aguas exteriores \n20 CM en aguas interiores', '22 CM en aguas exteriores \n18 CM en aguas interiores', '32 CM en aguas exteriores \n30 CM en aguas interiores'],
            audio: ['./antonito2.mp3', './antonito.mp3']
        },
        {
            nombre: 'BONITO LISTADO',
            url: './img/bonito.jpg',
            correct: 'Se recomienda 40 CM',
            suggested: ['Se recomienda 40 CM', 'Se recomienda 30 CM', 'Se recomienda 42 CM'],
            audio: ['./bonito.mp3']
        },
        {
            nombre: 'BRECA',
            url: './img/breca.jpg',
            correct: '22 CM',
            suggested: ['18 CM', '25 CM', '22 CM'],
            audio: ['./breca.mp3']
        },
        {
            nombre: 'DORADA',
            url: './img/dorada.jpg',
            correct: '19 CM',
            suggested: ['29 CM', '20 CM', '19 CM'],
            audio: ['./dorada.mp3']
        },
        {
            nombre: 'CHOPA',
            url: './img/chopa.jpg',
            correct: '23 CM en aguas exteriores \n19 CM en aguas interiores',
            suggested: ['30 CM en aguas exteriores \n20 CM en aguas interiores', '23 CM en aguas exteriores \n19 CM en aguas interiores', '20 CM en aguas exteriores \n15 CM en aguas interiores'],
            audio: ['./chopa.mp3', './chopa2.mp3']
        },
        {
            nombre: 'SEIFÍA',
            url: './img/seifa.jpg',
            correct: '22 CM',
            suggested: ['22 CM', '20 CM', '19 CM'],
            audio: ['./general1.mp3', './general2.mp3', './general3.mp3']
        },
        {
            nombre: 'CABRILLA NEGRA',
            url: './img/cabrillanegra.jpg',
            correct: '20 CM en aguas exteriores \n15 CM en aguas interiores',
            suggested: ['25 CM en aguas exteriores \n20 CM en aguas interiores', '26 CM en aguas exteriores \n21 CM en aguas interiores', '20 CM en aguas exteriores \n15 CM en aguas interiores'],
            audio: ['./cabrilla.mp3']
        },
        {
            nombre: 'CABALLA',
            url: './img/caballa.jpg',
            correct: '20 CM',
            suggested: ['22 CM', '24 CM', '20 CM'],
            audio: ['./caballa1.mp3', './caballa2.mp3', './caballa3.mp3']
        },
        {
            nombre: 'VIEJA',
            url: './img/vieja.jpg',
            correct: '22 CM en aguas exteriores \n20 CM en aguas interiores',
            suggested: ['25 CM en aguas exteriores \n20 CM en aguas interiores', '22 CM en aguas exteriores \n20 CM en aguas interiores', '25 CM en aguas exteriores \n22 CM en aguas interiores'],
            audio: ['./vieja.mp3']
        },
        {
            nombre: 'LUBINA',
            url: './img/lubina.jpg',
            correct: '36 CM',
            suggested: ['36 CM', '40 CM', '30 CM'],
            audio: ['./lubina.mp3']
        },
        {
            nombre: 'MERO',
            url: './img/mero.jpg',
            correct: '45 CM',
            suggested: ['55 CM', '40 CM', '45 CM'],
            audio: ['./mero.mp3']
        },
        {
            nombre: 'MORENA PINTADA',
            url: './img/morenapintada.jpg',
            correct: 'Se recomienda 45 CM',
            suggested: ['Se recomienda 40 CM', 'Se recomienda 45 CM', 'Se recomienda 35 CM'],
            audio: ['./general1.mp3', './general2.mp3', './general3.mp3']
        },
        {
            nombre: 'BOCINERO',
            url: './img/bocinero.jpg',
            correct: '28 CM en aguas exteriores \n33 CM en aguas interiores',
            suggested: ['28 CM en aguas exteriores \n33 CM en aguas interiores', '30 CM en aguas exteriores \n35 CM en aguas interiores', '33 CM en aguas exteriores \n28 CM en aguas interiores'],
            audio: ['./bocinero.mp3']
        },
        {
            nombre: 'PULPO',
            url: './img/pulpo.jpg',
            correct: '1 KG',
            suggested: ['2 KG', '1 KG', '1.5 KG'],
            audio: ['./pulpo.mp3', './pulpo2.mp3']
        },
        {
            nombre: 'SALEMA',
            url: './img/salema.jpg',
            correct: '24 CM',
            suggested: ['18 CM', '20 CM', '24 CM'],
            audio: ['./salema.mp3', './salema2.mp3']
        },
        {
            nombre: 'SALMONETE',
            url: './img/salmoncete.jpg',
            correct: '15 CM',
            suggested: ['18 CM', '15 CM', '20 CM'],
            audio: ['./general1.mp3', './general2.mp3', './general3.mp3']
        },
        {
            nombre: 'SAMA DE PLUMA',
            url: './img/samadepluma.jpg',
            correct: '35 CM',
            suggested: ['35 CM', '25CM', '30 CM'],
            audio: ['./samadepluma.mp3', './samadeplumas2.mp3']
        },
        {
            nombre: 'SARGO BLANCO',
            url: './img/sargoblanco.jpg',
            correct: '22 CM',
            suggested: ['20 CM', '22 CM', '18 CM'],
            audio: ['./sargoblanco.mp3']
        },
        {
            nombre: 'CAMARÓN SOLDADO',
            url: './img/camaron.jpg',
            correct: 'Se recomienda 15,6 MM (Caparazón)',
            suggested: ['Se recomienda 15,6 MM (Caparazón)', 'Se recomienda 18,5 MM (Caparazón)', 'Se recomienda 15 MM (Caparazón)'],
            audio: ['./comocamaron.mp3']
        },
        {
            nombre: 'LAPAS',
            url: './img/lapas.jpg',
            correct: '4,5 CM (diámetro de concha)',
            suggested: ['5,5 CM (diámetro de concha)', '4,5 CM (diámetro de concha)', '6,5 CM (diámetro de concha)'],
            audio: ['./lapas2.mp3', './lapas1.mp3']
        },
    ],
    showEstudiar: function () {
        let container = document.querySelector('.areadestudio');
        container.style.display = 'flex';
        if (container.childElementCount > 1) return;
        let titulo = document.createElement('h3');
        titulo.className = 'gameover';
        titulo.innerText = 'TALLAS MINIMAS';
        container.appendChild(titulo);
        game.easyData.sort(function (a, b) {
            if (a.nombre < b.nombre) { return -1; }
            if (a.nombre > b.nombre) { return 1; }
            return 0;
        });
        game.easyData.forEach(fish => {
            let miniContainer = document.createElement('div');
            miniContainer.className = 'tarjeta';
            container.appendChild(miniContainer);
            miniContainer.appendChild(help.getPhotoWithTittle(fish));
            let value = document.createElement('p');
            value.innerText = fish.correct;
            miniContainer.appendChild(value);
        });
        let button = document.createElement('button');
        container.appendChild(button);
        button.className = 'sticky';
        button.innerText = 'CERRAR';
        button.onclick = function () {
            container.style.display = 'none';
            window.history.pushState("", "inicio");
        }
    },
    init: function () {
        document.querySelector('.introdiv').style.display = 'flex';

        if (document.querySelector('.instrucciones') !== null)
            document.querySelector('.instrucciones').style.display = 'none';


        if (help.audio) {
            let src = help.barajar(['./fallo1.mp3', './fallo3.mp3', './fallo5.mp3'])[0];
            help.hablar(src);
            help.stopMusic();
        }

        let titulo = document.querySelector('.titulo');
        for (let i = 1; i < 10; i += 0.2) {
            titulo.style.fontSize = i + 'rem';
            if (help.isTextBiggerThan(titulo, window.innerWidth)) {
                titulo.style.fontSize = (i - 0.2) + 'rem';
                titulo.classList.add('bounceanimation');
                break;
            }
        }
        let subtitulo = document.querySelector('.subtitulo');
        subtitulo.classList.remove('puffanimation');
        for (let i = 1; i < 10; i += 0.2) {
            subtitulo.style.fontSize = i + 'rem';
            if (help.isTextBiggerThan(subtitulo, window.innerWidth)) {
                subtitulo.style.fontSize = (subtitulo.style.fontSize.replace('rem', '') / 2) + 'rem';
                subtitulo.classList.add('puffanimation');
                break;
            }
        }
        let besugo = document.querySelector('.beshugo');
        besugo.style.display = 'block';
        let pecera = document.querySelector('.intropecera');
        pecera.classList.remove('escaperight');
        pecera.appendChild(besugo);


        if (!game.savedName)
            document.querySelector('.introdiv .startbutton').onclick = function (e) {
                game.start();
                window.history.pushState("juego", "juego");
                if (!game.savedName) {
                    aCtx = createAudioContext();
                }
            }

        document.querySelector('.areadestudio').style.display = 'none';
        if (!game.savedName)
            document.querySelector('.introdiv .estudiar').onclick = function (e) {
                window.history.pushState("estudio", "estudio");
                game.showEstudiar();
            }

    },
    start: function () {
        help.barajar(game.easyData);
        //SOLO MOSTRAR INSTRUCCIONES LA PRIMERA VEZ
        //Luego comenzar el juego directamente desde esta función
        game.currentQuestion = 0;
        game.vidas = 3;
        document.getElementById('puntuacion').innerText = '0';
        let introdiv = document.querySelector('.introdiv');
        let pez = document.querySelector('.intropecera');
        pez.classList.add('escaperight');
        let besugo = document.querySelector('.beshugo');
        let pecera = document.querySelector('.instrucciones .pecera');
        if (document.querySelector('.instrucciones') !== null) {
            document.querySelector('.instrucciones').style.display = 'flex';
            dbHelper.preload();
            document.querySelector('.instrucciones button').onclick = function () {
                //Las instrucciones no hace falta sacarlas otra vez. 
                document.querySelector('.juegocontainer').style.display = 'flex';
                let besugo = document.querySelector('.beshugo');
                let pecera = document.querySelector('.header .pecera');
                pecera.appendChild(besugo);
                pecera.style.width = pecera.getBoundingClientRect().height + 'px';
                document.body.removeChild(document.querySelector('.instrucciones'));
                game.preguntar();
                help.startMusic();
            }
            help.hablar('./instrucciones.mp3');

            setTimeout(function () {
                introdiv.style.display = 'none';
                document.querySelector('.instrucciones').style.display = 'flex';
                pecera.appendChild(besugo);
            }, 100);
        } else {
            document.querySelectorAll('.vida').forEach(element => element.classList.remove('pezmuerte'));
            document.querySelector('.juegocontainer').style.display = 'flex';
            let besugo = document.querySelector('.beshugo');
            let pecera = document.querySelector('.header .pecera');
            pecera.appendChild(besugo);
            pecera.style.width = pecera.getBoundingClientRect().height + 'px';
            introdiv.style.display = 'none';
            game.preguntar();
            help.startMusic();
        }
    },
    preguntar: function () {
        if (typeof game.easyData[game.currentQuestion] !== 'undefined') {
            game.aceptarRespuestas = true;
            help.barajar(game.easyData[game.currentQuestion].suggested);
            game.showThisFish(game.easyData[game.currentQuestion], document.querySelector('.juego'));
        } else {
            game.gameOver(true);
        }
    },
    startBackground: function () {
        const peces = document.querySelector('.fish');
        const backPeces = document.querySelector('.backfish');
        help.randomIntervallCaller(2000, 20000, function () {
            let pecesArray = document.querySelectorAll('.fish');
            if (pecesArray.length > 10) {
                document.body.removeChild(Array.from(pecesArray)[1]);
            }
            let newPeces = peces.cloneNode(true);
            newPeces.style.top = Math.floor((Math.random() * 20 + 30)) + '%';
            newPeces.style.transform = 'scale(' + (Math.random() * 1 + 0.3) + ')';
            newPeces.style.zIndex = '-1';

            document.body.appendChild(newPeces)
        });

        help.randomIntervallCaller(4000, 15000, function () {
            let pecesArray = document.querySelectorAll('.backfish');
            if (pecesArray.length > 20) {
                document.body.removeChild(Array.from(pecesArray)[1]);
            }
            let newPeces = backPeces.cloneNode(true);
            newPeces.style.top = Math.floor((Math.random() * 10 + 50)) + '%';
            let scale = (Math.random() * 0.2 + 0.2);
            newPeces.style.transform = 'scale(-' + scale + ',' + scale + ')';
            newPeces.style.zIndex = '-2';

            document.body.appendChild(newPeces)
        });

        help.randomIntervallCaller(1000, 5000, function () {
            help.besugoOjo((Math.random() * 2) - 1, (Math.random() * 2) - 1);
        });
    },
    checkRespuesta: function (value) {
        if (!game.aceptarRespuestas) return;
        if (game.easyData[game.currentQuestion].correct == value.innerHTML.replace('<br>', '\n')) {
            game.aceptarRespuestas = false;
            game.currentQuestion++;
            value.parentElement.style.border = '4px solid green';
            game.acierto();
            setTimeout(game.preguntar, 2000);
        } else {
            //no volver a aceptar clicks, estaría guay hacer algo pero ahora solo podemos soñar
            value.parentElement.onclick = function () { };
            value.parentElement.classList.remove('shake-horizontal');
            value.parentElement.style.border = '4px solid red';
            value.parentElement.classList.add('shake-horizontal');
            game.perderUnaVida();
        }
    },
    refreshBar: function () {
        let value = document.querySelector('.value');
        let numero = value.style.width.replace('%', '') * 1;
        numero -= 0.15;
        if (numero < 0)
            numero = 0;
        value.style.width = numero + '%';
    },
    stopBar: function () {
        clearInterval(game.interval);
    },
    showThisFish: function (fish, container) {
        if (container.children) {
            Array.from(container.children).forEach(child => {
                container.removeChild(child);
            })
        }
        if (fish.audio) {
            help.barajar(fish.audio);
            let src = fish.audio[0];
            help.hablar(src);
        }
        let value = document.querySelector('.value');
        value.style.width = '100%';
        game.interval = setInterval(game.refreshBar, 50);
        container.appendChild(help.getPhotoWithTittle(fish));
        let pregunta = document.createElement('h2');
        pregunta.innerText = '¿Cuál es la talla mínima?';
        container.appendChild(pregunta);
        container.appendChild(help.createOpcion(fish.suggested[0]));
        container.appendChild(help.createOpcion(fish.suggested[1]));
        container.appendChild(help.createOpcion(fish.suggested[2]));
        let separator = document.createElement('div');
        separator.className = 'separator';
        container.appendChild(separator);
    },
    acierto: function () {
        let container = document.querySelector('.juego');
        let gameover = document.createElement('h1');
        gameover.innerText = '¡CORRECTO!';
        gameover.className = 'gameover';
        gameover.style.color = 'green';
        gameover.style.position = 'absolute';
        gameover.style.textAlign = 'center';
        gameover.style.top = '50%';
        container.appendChild(gameover);
        help.maxWidth(gameover);
        gameover.classList.add('puffanimation');



        clearInterval(game.interval);
        let puntuacion = document.getElementById('puntuacion');
        let value = document.querySelector('.value');
        let numero = value.style.width.replace('%', '') * 1;
        numero = Math.floor(numero);
        if (numero < 0)
            numero = 0;
        puntuacion.innerText = (puntuacion.innerText * 1) + 500 + (numero * 5);
        //AÑADIR UNA ANIMACIÓN CON EL EXTRA CONSEGUIDO
        puntuacion.parentElement.classList.add('saltaclass');
        setTimeout(function () {
            puntuacion.parentElement.classList.remove('saltaclass');
        }, 1000);
    },
    mostrarTop: function () {
        let src = help.barajar(['./olimpo.mp3', './olimpo2.mp3'])[0];
        help.hablar(src);
        let container = document.querySelector('.juego');
        if (container.children) {
            Array.from(container.children).forEach(child => {
                container.removeChild(child);
            })
        }
        let titulo = document.createElement('h1');
        titulo.className = 'gameover';
        titulo.innerText = 'ToP 50';
        let boton = document.createElement('button');
        boton.innerText = 'VOLVER';
        boton.onclick = function () {
            document.querySelector('.juegocontainer').style.display = 'none';
            game.init();
        };
        container.appendChild(boton);
        container.appendChild(titulo);
        if (game.results && game.results.length > 49) {
            game.results.push(game.lastsaved);
            game.results.sort(function (a, b) {
                if (a.s < b.s) { return 1; }
                if (a.s > b.s) { return -1; }
                return 0;
            });

            while (game.results.length > 50)
                game.results.pop();
            drawTop50();
        } else {
            dbHelper.db.getTop().then((results) => {
                game.results = results;
                drawTop50();
            });
        }

        function drawTop50() {
            let list = document.createElement('ol');
            container.appendChild(list);
            game.results.forEach(result => {
                let scorecontainer = document.createElement('div');
                let element = document.createElement('li');
                element.appendChild(scorecontainer);
                scorecontainer.className = 'score';
                let nombre = document.createElement('p');
                scorecontainer.appendChild(nombre);
                nombre.innerText = result.n;
                if (result.n == game.savedName) {
                    nombre.style.color = 'red';
                }
                let puntos = document.createElement('p');
                if (result.n == game.savedName) {
                    puntos.style.color = 'red';
                }
                scorecontainer.appendChild(puntos);
                puntos.innerText = result.s;
                list.appendChild(element);
            })
        }
    },
    gameOver: function (gano) {
        help.stopMusic();
        clearInterval(game.interval);
        //MOSTRAR UN TERMINADO! O GAMEOVER!
        let container = document.querySelector('.juego');
        if (container.children) {
            Array.from(container.children).forEach(child => {
                container.removeChild(child);
            })
        }
        let gameover = document.createElement('h1');
        if (!gano)
            gameover.innerText = 'GAMEOVER';
        else
            gameover.innerText = 'TERMINADO';
        gameover.className = 'gameover';

        gameover.classList.add('puffanimation');
        container.appendChild(gameover);
        //DECIR ALGO
        let src = gano ? './felicitaciones.mp3' : './gameover.mp3';
        help.hablar(src);

        setTimeout(function () {
            let gameover = document.querySelector('.gameover');
            gameover.parentElement.removeChild(gameover);
            let titulo = document.createElement('h1');
            titulo.className = 'gameover';
            container.appendChild(titulo);
            titulo.innerText = 'Nombre:';
            let input = document.createElement('input');
            if (game.savedName)
                input.value = game.savedName;
            input.setAttribute('type', 'text');
            input.setAttribute('maxlength', '30');
            container.appendChild(input);
            let button = document.createElement('button');
            container.appendChild(button);
            button.innerText = 'LISTO';
            button.onclick = async function () {
                //TODO ESTO ES MUY HACKEABLE
                game.savedName = input.value;
                game.lastsaved = {
                    n: input.value,
                    s: document.getElementById('puntuacion').innerText * 1
                };
                dbHelper.db.guardar(game.lastsaved);
                /*
                await addDoc(collection(db, "scores"), {
                    n: input.value,
                    s: document.getElementById('puntuacion').innerText * 1
                });*/
                game.mostrarTop();
            }
        }, 2000);

        //container.appendChild()
    },
    perderUnaVida: function () {
        game.vidas--;
        document.querySelector('.vidas svg:not(.pezmuerte)').classList.add('pezmuerte');
        if (game.vidas < 1) {
            game.gameOver();
        } else {
            let container = document.querySelector('.juego');
            let gameover = document.createElement('h1');
            gameover.innerText = 'FALLO!';
            gameover.className = 'gameover';
            gameover.style.color = 'red';
            gameover.style.position = 'absolute';
            gameover.style.textAlign = 'center';
            gameover.style.top = '50%';
            container.appendChild(gameover);
            help.maxWidth(gameover);
            gameover.classList.add('puffanimation');
            setTimeout(function () {
                container.removeChild(gameover);
            }, 1500);
        }
        /*
        else {
            let src = help.barajar(['./fallo1.mp3', './fallo2.mp3', './fallo3.mp3', './fallo4.mp3', './fallo5.mp3'])[0];
            help.hablar(src);
        }
        */
    }
}

window.onpopstate = function (event) {
    if (event.state) {
        if (event.state == 'juego') {
            game.start();
        }

        if (event.state == 'estudio') {
            game.showEstudiar();
        }
        if (event.state == '') {
            game.init();
        }
    } else {
        game.init();
    }
}
window.history.pushState("", "inicio");
game.startBackground();
game.init();

//Preload all images
for (var i in game.easyData) {
    preloadImg(game.easyData[i].url);
}
